import { CONTENT_TYPE_FIELD, CpsDocumentMetadataValue, DOC_ID_FIELD, CpsSearchExportRequest } from '@cs-cms/types';
import { SVGIcon } from '@progress/kendo-svg-icons';

export enum ActionItemId {
  GROUP = 'group',
  ADD_NEW = 'addNew',
  CREATE_SIMILAR = 'createSimilar',
  CREATE_FROM_CELL = 'createFromCell',
  FILTER_BY_CELL = 'filterByCell',
  DISPLAY_METADATA = 'displayMetadata',
  EDIT = 'edit',
  DOWNLOAD = 'download',
  EXPORT = 'export',
  LOCK = 'lock',
  UNLOCK = 'unlock',
  DELETE = 'delete',
  NO_ACTIONS = 'noActions'
}

export interface DropDownButtonItem {
  id: ActionItemId;
  text: string;
  svgIcon?: SVGIcon;
  groupId?: string;
  isHidden?: boolean;
  isDisabled?: boolean;
  className?: string;
}

export const CONFIRM_DIALOG = {
  MAX_EXPORT_ITEMS: 'MAX_EXPORT_ITEMS',
  TOO_MANY_REQUESTS: 'TOO_MANY_REQUESTS'
};

export const ACTION_GROUPS = {
  DOCUMENT_GROUP: 'documentGroup',
  GRID_GROUP: 'gridGroup'
};

export type ConfirmDialogType = (typeof CONFIRM_DIALOG)[keyof typeof CONFIRM_DIALOG];

export interface EditedDocument {
  [CONTENT_TYPE_FIELD]: string;
  [DOC_ID_FIELD]: string;
}

export interface TooManyRequestsTimer {
  querySearchExport: CpsSearchExportRequest;
  timeLeft: number;
}

export interface ClickedCellMetadata {
  fieldName: string;
  value: Exclude<CpsDocumentMetadataValue, undefined>;
  contentType: string;
}
